import { combineReducers } from 'redux'

import { IDigitainState } from '../types'
import communications from './communications'
import data from './data'

export const reducer = combineReducers<IDigitainState>({
  communications,
  data,
})
